export default "__VITE_ASSET__DWwlcvXQ__"